import React, { useState } from 'react';
import { Image, ImageBackground, Linking, StatusBar } from 'react-native';
import { View } from 'react-native';
import { Button, Text, TextInput, useTheme } from 'react-native-paper';
import { NavigationWithProps } from '../../core/Types';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Background, Pet } from '../../assets/images';
import { useToast } from 'react-native-toast-notifications';
import { useAuth } from '../../core/api/auth';
import { RootNavParamList } from '../../../App';
import { useMe } from '../../core/api/me';
import TextInputV2 from '../../components/TextInput';

const RequestUserName: React.FC<NavigationWithProps<{}, RootNavParamList, "RequestUserName">> = ({ navigation, route }) => {

    const theme = useTheme();
    const me = useMe();
    const toast = useToast();

    const [name, setName] = useState("");
    const [error, setError] = useState("");

    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const onError = () => {
        console.log('Error:', 'Error');
        toast.show("Error al iniciar sesión", { duration: 1000 });
    }

    const updateName = (name: string) => {
        setName(name);
        setError("");

        if (!submitted) {
            return;
        }

        validateForm(name);
    };

    const validateForm = (name: string) => {
        if (name === "") {
            setError("El nombre no puede estar vacío");
            return false;
        }

        if (name.length < 3) {
            setError("El nombre debe tener al menos 3 caracteres");
            return false;
        }

        if (name.length > 50) {
            setError("El nombre no puede tener más de 50 caracteres");
            return false;
        }

        return true;
    };

    const submitName = () => {
        setSubmitted(true);

        if (!validateForm(name)) {
            return;
        }

        setLoading(true);
        me.updateMyProfile({
            full_name: name
        })
            .then(() => {
                toast.show("Nombre guardado correctamente", { duration: 1000 });
                navigation.replace("Pages");
            })
            .catch(e => {
                toast.show("Error al guardar el nombre", { duration: 1000 });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <SafeAreaView style={{ flex: 1 }}>
            <StatusBar
                barStyle={theme.dark ? "light-content" : "dark-content"}
                backgroundColor="transparent"
                translucent={true}
            />
            <ImageBackground
                style={{ flex: 1, paddingHorizontal: 20 }}
                source={Background.fullscreen}>
                <View style={{
                    alignItems: "center",
                    marginTop: 70
                }}>
                    <Image
                        source={Pet.greetingsFront}
                        style={{
                            objectFit: "contain",
                            width: 150,
                            height: 150,
                        }}
                    />
                </View>

                <Text style={{
                    fontSize: 25,
                    textAlign: "center",
                    marginTop: 40,
                    marginBottom: 20,
                }}>
                    Introduce tu nombre completo para continuar
                </Text>

                <TextInputV2
                    label="Nombre"
                    value={name}
                    error={error !== ""}
                    errorMessage={error}
                    onChangeText={updateName}
                />

                <View style={{
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    marginTop: 50
                }}>
                    <Button mode="contained" onPress={submitName} loading={loading}>
                        Continuar
                    </Button>
                </View>

                <Text style={{
                    marginTop: "auto",
                    marginBottom: 130,
                    fontSize: 18,
                    textAlign: "center",

                }}>
                    Este será el nombre que vea tu terapeuta cuando solicites una cita.
                </Text>

            </ImageBackground>
        </SafeAreaView >
    );
}

export default RequestUserName;
